import { applyToText } from './text';
export function wrapIt(node, wordWrapWidth, maxLines, textBaseline) {
  if (maxLines === void 0) {
    maxLines = 2;
  }
  if (textBaseline === void 0) {
    textBaseline = 'top';
  }
  applyToText(node, {
    wordWrap: true,
    wordWrapWidth: wordWrapWidth,
    maxLines: maxLines,
    textBaseline: textBaseline
  });
}